import BaseService from './_base.service';

export const focalService = {
    page,
    search,
    combo,
    edit,
    create,
    one,
    remove,
    removeLogic
};

function page(page,size, callback) {
    return BaseService.get("/lens/attr/focal/page/"+page+"/"+size, callback)
}
function search(page,size,filter, callback) {
    return BaseService.post("/lens/attr/focal/page/"+page+"/"+size,filter, callback, true)
}
function combo(callback) {
    return BaseService.get("/lens/attr/focal/combo/", callback,)
}

function edit(id, bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.put("/lens/attr/focal/"+id, body, callback, false)
}

function create(bodyelement, callback) {
    let body = JSON.stringify(bodyelement)
    return BaseService.post("/lens/attr/focal/", body, callback, false)
}

function one(id,callback) {
    return BaseService.get("/lens/attr/focal/one/"+id, callback);
}

function remove(id,callback) {
    return BaseService.delete("/lens/attr/focal/"+id, callback);
}

function removeLogic(id,callback) {
    return BaseService.delete("/lens/attr/focal/"+id+"/logic", callback);
}
